import React, { useState } from 'react';
import { Shield, Loader } from 'lucide-react';
import { aiAPI } from '../services/api';
import toast from 'react-hot-toast';
import MarkdownRenderer from './MarkdownRenderer';
import StatsAndTabs from './StatsAndTabs';

const Compliance = ({ onSuccess, stats, loading: statsLoading }) => {
  const [formData, setFormData] = useState({
    regulation: '',
    documentContent: ''
  });
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.regulation.trim() || !formData.documentContent.trim()) {
      toast.error('Please fill in all fields');
      return;
    }

    setLoading(true);
    setResult('');

    try {
      const response = await aiAPI.checkCompliance({
        regulation: formData.regulation,
        documentContent: formData.documentContent
      });

      setResult(response.result);
      toast.success('Compliance check completed!');
      
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      console.error('Compliance check failed:', error);
      toast.error('Failed to check compliance');
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    setFormData({
      regulation: '',
      documentContent: ''
    });
    setResult('');
  };

  return (
    <div>
      <div className="content-header">
        <div className="welcome-section">
          <h2>Compliance Check</h2>
          <p>Ensure documents meet regulatory requirements</p>
        </div>
      </div>

      <StatsAndTabs stats={stats} loading={statsLoading} />

      <div className="tool-content">
        <div className="tool-header">
          <Shield size={24} />
          <h3>Compliance Checker</h3>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Regulation/Standard</label>
            <input
              type="text"
              name="regulation"
              className="form-input"
              placeholder="Enter regulation or compliance standard..."
              value={formData.regulation}
              onChange={handleChange}
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Document Content</label>
            <textarea
              name="documentContent"
              className="form-textarea"
              placeholder="Paste document content to check for compliance..."
              value={formData.documentContent}
              onChange={handleChange}
              disabled={loading}
              style={{ minHeight: '200px' }}
            />
          </div>

          <div style={{ display: 'flex', gap: '12px' }}>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? (
                <>
                  <Loader size={16} className="animate-spin" />
                  Checking Compliance...
                </>
              ) : (
                <>
                  <Shield size={16} />
                  Check Compliance
                </>
              )}
            </button>

            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleClear}
              disabled={loading}
            >
              Clear
            </button>
          </div>
        </form>
      </div>

      {result && (
        <div className="tool-content">
          <div className="tool-header">
            <Shield size={24} />
            <h3>Compliance Results</h3>
          </div>
          
          <MarkdownRenderer content={result} />

          <div style={{ marginTop: '16px' }}>
            <button
              className="btn btn-secondary"
              onClick={() => navigator.clipboard.writeText(result)}
            >
              Copy Results
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Compliance;
